import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styled from 'styled-components';
import { Select } from 'antd';
import { StarFilled } from '@ant-design/icons';

import { getAppName } from '../../appUtils';

import style from './index.scss';

const { Option } = Select;

const StyledProductsOptionContent = styled('p')`
  display: flex;
  margin: 0;
  color: #748aa1;
  gap: 4px;

  .star {
    display: flex;
    align-items: center;
    color: #d9d9d9;
  }
  .divider {
    color: #d9d9d9;
    margin: 0 6px;
  }
  .star.active {
    color: #f6b109;
  }
  .star-container {
    display: flex;
    margin-left: auto;
  }
`;

const ProductsDropdown = ({
  authentication,
  productLogin,
  putChangeDefaultRole,
  setCurrentProduct
}) => {
  const userModules = authentication.userModules?.data || [];
  const productsSelectRef = useRef(null);
  const { currentProductLogin } = authentication;

  const handleProductsSelectChange = (value) => {
    const selectedItem = userModules.find((m) => m.roleCode === value.value);
    if (selectedItem) {
      productLogin(selectedItem);
      setCurrentProduct(selectedItem);
      localStorage.setItem('roleCode', selectedItem.roleCode);
    }
  };

  const handleProductsStarClick = (e, product) => {
    e.stopPropagation();
    productsSelectRef.current?.blur();
    putChangeDefaultRole({
      roleCode: product.roleCode,
      moduleCode: product.moduleCode,
      isDefault: !product.isDefault
    });
  };

  return (
    <Select
      id="products-select"
      className={classnames(style.productsSelect)}
      onChange={handleProductsSelectChange}
      size="small"
      labelInValue
      value={{
        value: currentProductLogin?.roleCode,
        label: currentProductLogin?.moduleCode
      }}
      ref={productsSelectRef}>
      {userModules
        ?.filter(
          (pr) =>
            pr.applicationId !== 0 &&
            pr.applicationId !== 2 &&
            pr.moduleId !== 0
        )
        ?.map((pr) => (
          <Option value={pr.roleCode} key={pr.roleCode} title={pr.moduleCode}>
            <StyledProductsOptionContent>
              <span className="text text-truncate">{pr.moduleCode}</span>
              <span className="star-container">
                <span className="divider">|</span>
                <StarFilled
                  onClick={(e) => handleProductsStarClick(e, pr)}
                  className={classnames('star', { active: pr.isDefault })}
                />
              </span>
            </StyledProductsOptionContent>
          </Option>
        ))}
    </Select>
  );
};

ProductsDropdown.propTypes = {
  authentication: PropTypes.object,
  productLogin: PropTypes.func,
  putChangeDefaultRole: PropTypes.func,
  onSwitchApp: PropTypes.func,
  setCurrentProduct: PropTypes.func
};

export default ProductsDropdown;
